import 'react-medium-image-zoom/dist/styles.css';
import { FaSearch } from 'react-icons/fa';
import PropTypes from 'prop-types';

const Searchbar = ({ placeholder, value, onChange }) => {
  return (
    <div className='searchbar'>
      <div className='icon-input'>
        <FaSearch className='icon' />
        <input
          type='search'
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className='search-input'
        />
      </div>
    </div>
  );
};

Searchbar.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Searchbar;
